import { usePublicLanguage } from "../../context/PublicLanguage";
import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { publicApi } from "@/lib/api";

// Temporarily paused. Re-enable this one switch after subscription is ready.
export const NEWSLETTER_ENABLED = false;

export default function Newsletter() {
  return NEWSLETTER_ENABLED ? <NewsletterForm /> : null;
}

function NewsletterForm() {
  const { t } = usePublicLanguage();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await publicApi.subscribe(email.trim());
      toast.success(t("Subscribed."));
      setEmail("");
    } catch (err) {
      toast.error(t("Something went wrong. Try again."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="relative mt-16 rounded-xl overflow-hidden td-grain border"
      style={{ background: "linear-gradient(120deg, #111315 0%, #0c0d0e 100%)", borderColor: "rgba(255,138,31,0.2)" }}
    >
      <div
        className="absolute -top-24 -right-24 w-64 h-64 rounded-full opacity-20 blur-3xl"
        style={{ background: "#FF8A1F" }}
      />
      <div className="relative p-8 md:p-12 grid md:grid-cols-2 gap-8 items-center">
        <div>
          <div className="td-eyebrow mb-3" style={{ color: "#FF8A1F" }}>{t('Newsletter')}</div>
          <h2 className="font-display font-extrabold tracking-tight text-white text-3xl md:text-4xl mb-3" style={{ letterSpacing: "-0.02em" }}>{t('Get the Daily Dish')}</h2>
          <p className="text-[#A7ABB0] leading-relaxed" style={{ fontSize: "1.05rem" }}>{t('The technology that matters, served directly to your inbox.')}</p>
        </div>
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
          <input
            data-testid="newsletter-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com" aria-label={t("Email address")}
            className="flex-1 bg-[#08090A] border rounded-lg px-4 py-3.5 text-white placeholder:text-[#71767c] outline-none focus:border-[#FF8A1F]/60 transition-colors"
            style={{ borderColor: "rgba(255,255,255,0.1)" }}
          />
          <button
            data-testid="newsletter-submit"
            type="submit"
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 rounded-lg px-6 py-3.5 font-display font-semibold text-[#08090A] transition-transform active:scale-95 disabled:opacity-60"
            style={{ background: "linear-gradient(135deg, #FF8A1F, #FFB347)" }}
          >
            {loading ? <Loader2 size={17} className="animate-spin" /> : <>{t('Subscribe')}<ArrowRight size={16} /></>}
          </button>
        </form>
      </div>
    </section>
  );
}
